import React from 'react';
import { motion } from 'framer-motion';
import { ColumviLogo } from './ColumviLogo';
import { ColumviBackground } from './ColumviBackground';
interface ColumviCtaSlideProps {
  heading: string;
  subheading: string;
  primaryLabel: string;
  primaryUrl?: string;
  secondaryLabel?: string;
  secondaryUrl?: string;
}
export function ColumviCtaSlide({
  heading,
  subheading,
  primaryLabel,
  primaryUrl,
  secondaryLabel,
  secondaryUrl
}: ColumviCtaSlideProps) {
  const handlePrimaryClick = () => {
    if (primaryUrl) {
      window.open(primaryUrl, '_blank', 'noopener,noreferrer');
    }
  };
  const handleSecondaryClick = () => {
    if (secondaryUrl) {
      window.open(secondaryUrl, '_blank', 'noopener,noreferrer');
    }
  };
  return <ColumviBackground showWave animateWave={true} data-id="element-29">
      <div className="flex flex-col h-full px-6 py-8 pb-24" data-id="element-30">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} data-id="element-31">
          <ColumviLogo size="sm" variant="light" data-id="element-32" />
        </motion.div>

        {/* Centered Content */}
        <div className="flex-1 flex flex-col justify-center items-center text-center" data-id="element-33">
          <motion.h1 className="text-white text-2xl leading-tight mb-4" style={{
          fontFamily: 'var(--font-gotham)',
          fontWeight: 800
        }} initial={{
          opacity: 0,
          y: -15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} data-id="element-34">
            {heading}
          </motion.h1>

          <motion.p className="text-white/60 text-sm leading-relaxed mb-8" style={{
          fontFamily: 'var(--font-gotham)'
        }} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5
        }} data-id="element-35">
            {subheading}
          </motion.p>

          {/* Primary CTA */}
          <motion.button className="w-full py-4 rounded-xl text-white font-semibold text-sm transition-all duration-200" style={{
          fontFamily: 'var(--font-gotham)',
          background: '#E76F24',
          boxShadow: '0 4px 15px rgba(231,111,36,0.3)'
        }} initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.7
        }} whileHover={{
          scale: 1.02,
          boxShadow: '0 6px 20px rgba(231,111,36,0.4)'
        }} whileTap={{
          scale: 0.98
        }} onClick={handlePrimaryClick} data-id="element-36">
            {primaryLabel}
          </motion.button>

          {/* Secondary Link */}
          {secondaryLabel && <motion.button className="mt-4 text-sm text-white/50 hover:text-white/80 underline underline-offset-2 transition-colors duration-200" style={{
          fontFamily: 'var(--font-gotham)'
        }} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.9
        }} onClick={handleSecondaryClick} data-id="element-37">
              {secondaryLabel}
            </motion.button>}
        </div>
      </div>
    </ColumviBackground>;
}